import { API } from '@utils';

export const createCart = async (body: ICreateCartRequest) => {
  return API.post<ICartResponse>(`Cart`, {
    // CalculateAmounts: true, // FIXME
    ...body,
  });
};

export const getCart = async (cartKey: string) => {
  return API.get<ICartResponse>(`Cart/${cartKey}`);
};

export const getCartPayment = async (cartKey: string) => {
  return API.get<ICreatePaymentIntentResponse>(`Cart/${cartKey}/Payment`);
};

export const getBuyer = async (cartKey: string) => {
  return API.get<IBuyerResponse>(`Cart/${cartKey}/Buyer`);
};

export const getPurchasedTickets = async (transactionKey: string) => {
  return API.get<IPurchasedTicketsResponse>(
    `Transactions/${transactionKey}/Items`
  );
};

export const addToCart = async (cartKey: string, body: IUpdateCartRequest) => {
  return API.post<ICartAddItemResponse>(`Cart/${cartKey}/Items`, {
    ...body,
  });
};

export const removeFromCart = async (cartKey: string, cartItemKey: string) => {
  return API.delete<ICartResponse>(`Cart/${cartKey}/Items/${cartItemKey}`);
};

export const addPromoCodeToCart = async (cartKey: string, code: string) => {
  return API.put<ICartResponse>(`Cart/${cartKey}/PromoCode`, {
    PromoCode: code,
  });
};

export const deletePromoCodeFromCart = async (cartKey: string) => {
  return API.delete<ICartResponse>(`Cart/${cartKey}/PromoCode`);
};

export const saveBillingDetails = async (
  cartId: string,
  body: IBillingDetailsRequest
) => {
  return API.post<IBillingDetailsResponse>(`Cart/${cartId}/Buyer`, body);
};

export const convertCartToTransaction = async (cartId: string) => {
  return API.post<IConvertCartTransactionResponse>(`Transactions/FromCart`, {
    CartKey: cartId,
  });
};

export const getTransactionByKey = async (transactionKey: string) => {
  return API.get<IConvertCartTransactionResponse>(
    `Transactions/ByKey/${transactionKey}`
  );
};

export async function createPaymentIntent(
  cartId: string
): Promise<ICreatePaymentIntentResponse> {
  const res = await API.post<ICreatePaymentIntentResponse>(
    `Cart/${cartId}/Payment`
  );

  const data = (res as any).data ?? res;

  if (!data) {
    throw new Error('Empty payment intent response');
  }
  return data as ICreatePaymentIntentResponse;
}

export const deleteCart = async (cartId: string) => {
  return API.delete(`Cart/${cartId}`);
};

export const getTransaction = async (transactionId: number) => {
  return API.get<ITransactionResponse[]>(
    `AttendeeTicket/GetByTransaction?transaction_id=${transactionId}`
  );
};
